import {
    CHANGEUP, CIRCLECHANGE,
    CURVEBALL,
    CUTTER,
    FORK,
    FOURSEAM,
    PALMBALL,
    SCREWBALL,
    SLIDER,
    SLURVE,
    SPLITTER,
    TWOSEAM
} from "./pitches";

export const MIYUKI = { name: 'C | Miyuki Kazuya',
    role: 'Catcher | 3rd year | Tokyo',
    details: 'Throws Right, Bats Left',
    edu: 'Management, School of Commerce, Meiji University | Seidou High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Miyuki.PNG'
}

export const KURAMOCHI = { name: 'SS | Kuramochi Youichi',
    role: 'Shortstop | 3rd year | Ohara, Chiba Prefecture',
    details: 'Throws Right, Bats Left/Right',
    edu: 'Creative Business, School of Commerce, Meiji University | Seidou High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Mochi.JPG'
}

export const AMAHISA = { name: 'RHP | Amahisa Kousei',
    role: 'Pitcher | 3rd year | Tokyo',
    details: 'Throws Right',
    edu: 'Information and Communication, Meiji University | Ichidai Sankou High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Amahisa.png',
    stats: {
    pitch: [FOURSEAM, FORK, CURVEBALL, SLIDER],
    }
}

export const UMEMIYA = { name: 'RHP | Umemiya Seiichi',
    role: 'Pitcher | 3rd year | Tokyo',
    details: 'Throws Right',
    edu: 'Management, School of Commerce, Meiji University | Ugumori High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Umemiya.png',
    stats: {
        pitch: [FOURSEAM, CURVEBALL, SLURVE, SCREWBALL],
    }
}

export const ISE = { name: 'LHP | Ise Nobuyuki',
    role: 'Pitcher | 4th year | Osaka',
    details: 'Throws Left',
    edu: 'School of Global Japanese Studies, Meiji University | Osaka Toin High School',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Ise.png'
}

export const MINO = { name: 'CF | Mino Atsushi',
    role: 'Center Fielder | 4th year | Tokyo',
    details: 'Throws Right, Bats Left',
    edu: 'Marketing, School of Commerce, Meiji University | Meiji Nakano High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Mino.png'
}

export const ASO = { name: '1B | Aso Orochi',
    role: 'First Baseman | 4th year | Tokyo',
    details: 'Throws Right, Bats Right',
    edu: 'Information and Communication, Meiji University | Seidou High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Aso.png'
}

export const MORI = { name: '2B | Mori Satoru',
    role: 'Second Baseman | 2nd year | Yamaguchi Prefecture',
    details: 'Throws Right, Bats Left',
    edu: 'Literary arts and media, Meiji University | Shimonoseki International High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Mori.png'
}

export const OOTO = { name: '3B | Ooto Keiji',
    role: 'Third Baseman | 4th year | Yokohama',
    details: 'Throws Right, Bats Right',
    edu: 'School of Global Japanese Studies, Meiji University | Yokohama Sogo High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Ooto.png'
}

export const NAGATA = { name: 'LF | Nagata Jiro',
    role: 'Left Fielder | 2nd year | Fukushima Prefecture',
    details: 'Throws Left, Bats Left',
    edu: 'Global Business, School of Commerce, Meiji University | Seiko Gakuin High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Nagata.png'
}

export const OKADA = { name: 'RF | Okada Hajime',
    role: 'Right Fielder | 2nd year | Tokyo',
    details: 'Throws Right, Bats Right',
    edu: 'Management, School of Commerce, Meiji University | Meiji Nakano High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Okada.png'
}

export const MASU = { name: 'C | Masu Shinichirou',
    role: 'Catcher | 4th year | Tokyo',
    details: 'Throws Right, Bats Left',
    edu: 'School of Agriculture, Life science, Meiji University | Seikou Academy High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Masu.png'
}

export const IMAMURA = { name: 'C | Imamura Yoshio',
    role: 'Catcher | 2nd year | Aomori Prefecture',
    details: 'Throws Right, Bats Right',
    edu: 'School of Business administration, Meiji University | Misawa High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Imamura.png'
}

export const TAKU = { name: 'LHP | Takuya Terada',
    role: 'Pitcher | 2nd year | Gunma Prefecture',
    details: 'Throws Right, Bats Right',
    edu: 'School of Business administration, Meiji University | Osaka Toin High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Imamura.png'
}
